import download from "downloadjs";
import axios from "axios";

let CONV_API_URL = 'http://localhost:3003';
let UI_URL = 'http://localhost:3000/#';


if (!process.env.NODE_ENV || process.env.NODE_ENV === 'production') {
  CONV_API_URL = `${window.location.protocol}//${window.location.hostname}/api`;
  UI_URL = `${window.location.protocol}//${window.location.hostname}/#`;
}

const OMNI_API = axios.create({
  baseURL: CONV_API_URL,
  responseType: 'json',
  withCredentials: true,
  headers: {
    "Accept": "application/json",
    "X-Frame-Options": "DENY",
    "Cache-control": "no-store",
    "Pragma": "no-cache",
  }
})

const OK = (status) => status === 200;
const PARSE_RESULT = (res) => res.data;
const RETURN_ERROR = (err) => err.response ? (err.response.data ? err.response.data : err.response) : err;
const LOG_ERROR = (err) => { console.error(RETURN_ERROR(err)); }
const LOG_RETURN_ERROR = (err) => { LOG_ERROR(err); return RETURN_ERROR(err); }
const LOG_THROW_ERROR = (err) => { LOG_ERROR(err); throw RETURN_ERROR(err); }
export const CSRF = () => OMNI_API.get('/csrf').then(PARSE_RESULT);

OMNI_API.interceptors.request.use(async (config)=>{
   if(config?.method === 'post'){
      let csrf = await CSRF()
      config.headers['X-CSRF-TOKEN'] = csrf.token
   }
   return config
})

export const getChannels = () => OMNI_API.get('/channels').then(PARSE_RESULT).catch(LOG_ERROR);

export const getConversations = (
  channelId,
  startTime,
  endTime,
  sortBy,
  sortIsAscending,
  offSet,
  pageLimit,
  errorFilter,
  errorCompareOp,
  errorThreshold,
  stepsFilter,
  stepsCompareOp,
  stepsThreshold,
  ratingFilter,
  ratingsCompareOp,
  ratingThreshold,
  searchFilter,
  searchValue,
  promptFilter,
  promptValue,
  intentFilter,
  intentValue,
  tagFilter,
  tagValue,
  notesFilter,
  systemEventsFilter,
  systemEventsValue,
  activitiesFilter,
  activitiesValue,
  missingIntentFilter,
  missingInputFilter,
  dateFilter,
  startDateFilterValue,
  endDateFilterValue,
  channelFilter,
  channelValue,
  nluFilter,
  nluCompareOp,
  nluThreshold,
  asrFilter,
  asrCompareOp,
  asrThreshold,
  languageFilter,
  languageValue,
  dnisFilter,
  dnisValue,
  aniFilter,
  aniValue,
  channelTransferFilter,
  channelTransferValue
) => {
  let params = {
    offSet: offSet || 0,
    pageLimit: pageLimit || 100,
    sortOrder: sortIsAscending ? 'ASC' : 'DESC'
  }

  let add_threshold_filter = (name, filter, op, threshold) => {
    if (filter && op && parseInt(threshold) >= 0) {
      params[`${name}CompareOp`] = btoa(op);
      params[`${name}Threshold`] = threshold;
    }
  }

  if (startTime) params['startTime'] = startTime;
  if (endTime) params['endTime'] = endTime;
  if (sortBy) params['sortBy'] = sortBy;

  add_threshold_filter('error', errorFilter, errorCompareOp, errorThreshold);
  add_threshold_filter('steps', stepsFilter, stepsCompareOp, stepsThreshold);
  add_threshold_filter('rating', ratingFilter, ratingsCompareOp, ratingThreshold);
  add_threshold_filter('nlu', nluFilter, nluCompareOp, nluThreshold);
  add_threshold_filter('asr', asrFilter, asrCompareOp, asrThreshold);

  if (searchFilter && searchValue) params['searchVal'] = btoa(searchValue);
  if (promptFilter && promptValue) params['promptVal'] = btoa(promptValue.value);
  if (intentFilter && intentValue){
    if(intentValue.length) {
      let formattedIntentValues = '';
      intentValue.forEach(intent => {formattedIntentValues += intent.value + ','});
      params['intentVal'] = btoa(formattedIntentValues.replace(/,\s*$/, ""));
    } else {
      params['intentVal'] = btoa(intentValue.value);
    }
  }
  if (tagFilter && tagValue.length > 0) params['tagVal'] = btoa(tagValue.map((t) => t.value));
  if (notesFilter) params['hasNotes'] = true;
  if (missingIntentFilter) params['missingIntent'] = true;
  if (systemEventsFilter && systemEventsValue) params['sysEvtsVal'] = systemEventsValue;
  if (activitiesFilter && activitiesValue) params['activities'] = activitiesValue;
  if (missingInputFilter) params['missingInput'] = true;
  if (languageFilter && languageValue) params['languageValue'] = languageValue;
  if (aniFilter && aniValue) params['aniValue'] = aniValue;
  if (channelId) params['channels'] = channelId;

  if (dateFilter && startDateFilterValue && endDateFilterValue) {
    params['dateFilter'] = dateFilter;
    params['startDateFilterValue'] = startDateFilterValue;
    params['endDateFilterValue'] = endDateFilterValue;
  }

  if (dnisFilter && dnisValue) {
    params['dnisFilter'] = dnisFilter;
    params['dnisValue'] = dnisValue;
  }

  if (channelFilter && channelValue) {
    params['channelFilter'] = channelFilter;
    params['channelValue'] = channelValue;
  }

  if (channelTransferFilter && channelTransferValue)
  {
    params['channelTransferFilter'] = channelTransferFilter;
    params['channelTransferValue'] = channelTransferValue;
  }

  return OMNI_API.get('/conversations', { params: params })
    .then(PARSE_RESULT)
    .catch(LOG_ERROR);
};

export const getUltraliteMessages = (
  offset,
  limit,
  sortBy,
  isAscending,
  startTime,
  endTime,
  confidenceFilter,
  confidenceCompareOp,
  confidenceThreshold,
  intentFilter,
  intentValue,
  tagFilter,
  tagValue,
  searchFilter,
  searchValue,
  promptFilter,
  promptValue
  ) => {
    return OMNI_API.post('/ultralite/messages', {
      offset: offset,
      pageLimit: limit,
      sortBy: sortBy,
      isAscending: isAscending,
      startTime: startTime,
      endTime: endTime,
      confidenceFilter: confidenceFilter,
      confidenceCompareOp: confidenceCompareOp,
      confidenceThreshold: confidenceThreshold,
      intentFilter: intentFilter,
      intentValue: intentValue,
      tagFilter: tagFilter,
      tagValue: tagValue,
      searchFilter: searchFilter,
      searchValue: searchValue,
      promptFilter: promptFilter,
      promptValue: promptValue
    }).then(PARSE_RESULT).catch(LOG_ERROR);
};

export const getConversationById = conversationId => {
  return OMNI_API.get(`/conversations/${conversationId}`)
    .then((res) => res.data ? res.data.conversation : res.data)
    .catch(LOG_ERROR);
};

export const getUltraliteMessagesById = messageId => {
  return OMNI_API.get(`/ultralite/messages/${messageId}`)
    .then((res) => res.data ? res.data.message : res.data)
    .catch(LOG_ERROR);
};

export const getMessagesByConversationId = (conversationId, startTime) => {
  let params = {};
  if (startTime) params['startTime'] = startTime;

  return OMNI_API.get(`/conversations/${conversationId}/messages`)
    .then(PARSE_RESULT)
    .catch(LOG_ERROR);
};

export const flagConversation = (conversationId, flagged) => {
  return OMNI_API.post(`/conversations/${conversationId}/flag`, {
    flagged: flagged
  }).then(PARSE_RESULT);
};

export const flagMessage = (messageId, flagged) => {
  return OMNI_API.post(`/messages/${messageId}/flag`, {
    flagged: flagged
  }).then(PARSE_RESULT);
};

export const getSelectedVersions = () => {
  return OMNI_API.get('/global/versions/selected').then(PARSE_RESULT);
};

export const setSelectedTrainingDataVersion = (versionId) => {
  return OMNI_API.put('/intents&entities/versions/selected', {
    versionId: versionId
  }).then(PARSE_RESULT);
}

export const setSelectedPromptsVersion = (versionId) => {
  return OMNI_API.put('/prompts/versions/selected', {
    versionId: versionId
  }).then(PARSE_RESULT);
}

export const aggregateNLUData = () => {
  return OMNI_API.post('/intents&entities/aggregate').then(PARSE_RESULT);
}

export const aggregatePromptsData = () => {
  return OMNI_API.post('/prompts/aggregate').then(PARSE_RESULT);
}

export const getTrainingDataVersions = () => {
  return OMNI_API.get('/intents&entities/versions').then(PARSE_RESULT);
};

export const editTrainingDataVersion = (versionId, name, description, notes, freeze, release_date) => {
  return OMNI_API.put(`/intents&entities/${versionId}`, {
    name: name,
    description: description,
    release_date: release_date,
    notes: notes,
    freeze: freeze
  }).then(PARSE_RESULT);
}

export const createTrainingDataVersion = (name, description, notes, release_date) => {
  return OMNI_API.post('/intents&entities/versions', {
    name: name,
    description: description,
    release_date: release_date,
    notes: notes
  }).then(PARSE_RESULT);
};

export const cloneTrainingDataVersion = (versionId, name) => {
  return OMNI_API.post(`/intents&entities/${versionId}/clone`, {
    name: name
  }).then(PARSE_RESULT);
}

export const deleteTrainingDataVersion = (versionId) => {
  return OMNI_API.delete(`/intents&entities/${versionId}`).then(PARSE_RESULT);
}

export const getVersionIntents = (versionId) => {
  return OMNI_API.get(`/intents&entities/${versionId}/intents`).then(PARSE_RESULT);
};

export const getIntents = () => {
  return OMNI_API.get('/ultralite/intents')
    .then(PARSE_RESULT)
    .catch(LOG_ERROR);
};

export const addIntent = (intentName, versionId) => {
  return OMNI_API.post(`/intents&entities/${versionId}/intents`, {
    name: intentName
  }).then(PARSE_RESULT);
};

export const addPhrase = (intentId, phrase) => {
  return OMNI_API.post(`/intents&entities/intents/${intentId}/phrases`, {
    phrase: phrase
  }).then(PARSE_RESULT);
};

export const getVersionEntities = (versionId) => {
  return OMNI_API.get(`/intents&entities/${versionId}/entities`)
    .then(PARSE_RESULT)
    .catch(LOG_ERROR);
};

export const getTrainingPhrasesByVersionId = versionId => {
  return OMNI_API.get(`/intents&entities/${versionId}/phrases`).then(PARSE_RESULT);
};

export const getAllTrainingPhrases = () => {
  return OMNI_API.get('/ultralite/phrases')
    .then(PARSE_RESULT)
    .catch(LOG_ERROR);
};

export const getTrainingPhrases = (intentid) => {
  return OMNI_API.get(`/intents&entities/intents/${intentid}/phrases`)
    .then(PARSE_RESULT)
    .catch(LOG_ERROR);
};

export const getTrainingData = (versionId, versionName) => {
  return OMNI_API.post('/model', {
    versionId: versionId,
    versionName: versionName
  }).then(PARSE_RESULT);
};

export const getIdFromIntent = (intent) => {
  return OMNI_API.get(`/intents&entities/intents/id`, {
    params: { intent: intent }
  })
    .then(PARSE_RESULT)
    .catch(LOG_ERROR);
};

export const getIdFromPhrase = phrase => {
  return OMNI_API.get('/phrases/id', {
    params: { phrase: phrase }
  })
    .then(PARSE_RESULT)
    .catch(LOG_ERROR);
};

export const getIntentWords = intentId => {
  return OMNI_API.get(`/intents&entities/phrases/${intentId}/entities`)
    .then(PARSE_RESULT)
    .catch(LOG_ERROR)
}

export const getWords = tpId => {
  return OMNI_API.get(`/intents&entities/phrases/${tpId}/words`)
    .then(PARSE_RESULT)
    .catch(LOG_ERROR);
};

export const getUltraliteTraffic = (startTime, endTime) => {
  return OMNI_API.get('/ultralite/traffic', {
    params: { startTime: startTime, endTime: endTime }
  })
    .then(PARSE_RESULT)
    .catch(LOG_ERROR);
}

export const getTrafficData = (startTime, endTime, startTimeComp, endTimeComp, channelName=null) => {
  let params = { startTime: startTime, endTime: endTime, startTimeComp: startTimeComp, endTimeComp: endTimeComp };
  if (channelName) params['channelName'] = channelName;

  return OMNI_API.get('/analytics/traffic', { params: params })
    .then(PARSE_RESULT);
};

export const getTimelineData = (startTime, endTime, startTimeComp, endTimeComp) => {
  let params = { startTime: startTime, endTime: endTime, startTimeComp: startTimeComp, endTimeComp: endTimeComp };

  return OMNI_API.get('/analytics/timeline', { params: params })
    .then(PARSE_RESULT)
    .catch(LOG_ERROR);
};

export const getRatingsData = (startTime, endTime) => {
  return OMNI_API.get('/analytics/ratings', {
    params: { startTime: startTime, endTime: endTime }
  })
    .then(PARSE_RESULT)
    .catch(LOG_ERROR);
};

export const getEngagements = (startTime, endTime, channel) => {
  return OMNI_API.get('/analytics/engagements', {
    params: { startDate: startTime, endDate: endTime, channel: channel },
    body: channel
  })
  .then(PARSE_RESULT)
  .catch(LOG_ERROR);
};

export const getAvgSteps = (startTime, endTime) => {
  return OMNI_API.get('/analytics/engagements/avgSteps', {
    params: { startDate: startTime, endDate: endTime }
  })
  .then(PARSE_RESULT)
  .catch(LOG_ERROR);
};

export const getAvgDuration = (startTime, endTime) => {
  return OMNI_API.get('/analytics/engagements/avgDuration', {
    params: { startDate: startTime, endDate: endTime }
  })
  .then(PARSE_RESULT)
  .catch(LOG_ERROR);
};

export const getAvgErrors = (startTime, endTime) => {
  return OMNI_API.get('/analytics/engagements/avgErrors', {
    params: { startDate: startTime, endDate: endTime }
  })
  .then(PARSE_RESULT)
  .catch(LOG_ERROR);
};

export const getSynonyms = (eID) => {
  return OMNI_API.get(`/intents&entities/entities/${eID}/synonyms`)
    .then(PARSE_RESULT)
    .catch(LOG_ERROR);
};

export const getVersionPromptsData = (offset, limit, searchVal, versionId) => {
  let params = {};
  if (offset || offset === 0) params['offset'] = offset;
  if (limit) params['limit'] = limit;
  if (searchVal) params['searchVal'] = searchVal;

  return OMNI_API.get(`/prompts/${versionId}/prompts`, { params: params })
    .then(PARSE_RESULT);
};

export const getDefaultPrompts = (_offset, _searchVal) => {
  return OMNI_API.get('/prompts/default')
    .then((res) => res.data.prompts)
    .catch(LOG_ERROR);
}

export const getDefaultIntents = () => {
  return OMNI_API.get('/intents&entities/default')
    .then((res) => res.data.intents)
    .catch(LOG_ERROR);
}

export const getPrompts = (offset, searchVal) => {
  let params = {};
  if (offset) params['offset'] = offset;
  if (searchVal) params['searchVal'] = searchVal;

  return OMNI_API.get('/ultralite/prompts', { params: params })
    .then(PARSE_RESULT)
    .catch(LOG_ERROR);
};

export const getPromptsVersions = () => {
  return OMNI_API.get('/prompts/versions').then(PARSE_RESULT);
};

export const editPromptsVersion = (versionId, name, description, notes, release_date) => {
  return OMNI_API.put(`/prompts/${versionId}`, {
    versionId: versionId,
    name: name,
    description: description,
    release_date: release_date,
    notes: notes
  }).then(PARSE_RESULT);
}

export const createPromptsVersion = (name, description, notes, _, importLive, release_date) => {
  return OMNI_API.post('/prompts/versions', {
    name: name,
    description: description,
    notes: notes,
    release_date: release_date,
    importLive: importLive
  }).then(PARSE_RESULT);
}

export const clonePromptsVersion = (versionId, name) => {
  return OMNI_API.post(`/prompts/${versionId}`, {
    name: name
  }).then(PARSE_RESULT);
}

export const deletePromptsVersion = (versionId) => {
  return OMNI_API.delete(`/prompts/${versionId}`).then(PARSE_RESULT);
}

export const getContentFromId = cId => {
  return OMNI_API.get(`/prompts/${cId}/content`)
    .then(PARSE_RESULT)
    .catch(LOG_ERROR);
};

export const getPromptOptions = () => {
  return OMNI_API.get('/prompts/options')
    .then(PARSE_RESULT)
    .catch(LOG_ERROR);
};

export const getPromptGroups = (versionId) => {
  return OMNI_API.get(`/prompts/${versionId}/groups`)
    .then(PARSE_RESULT)
    .catch(LOG_ERROR);
};

export const addPrompt = (promptName, versionId, chat, voice, spanish, spanishVoice) => {
  return OMNI_API.post(`/prompts/${versionId}/prompts`, {
    promptName: promptName,
    chat: chat,
    voice: voice,
    spanish: spanish,
    spanishVoice: spanishVoice
  })
    .then(PARSE_RESULT)
    .catch(RETURN_ERROR)
}

export const addPromptGroup = (groupName, versionId) => {
  return OMNI_API.post(`/prompts/${versionId}/groups`, {
    groupName: groupName
  })
    .then(PARSE_RESULT)
    .catch(RETURN_ERROR);
}

export const deletePrompt = (versionId, contentId) => {
  return OMNI_API.delete(`/prompts/${versionId}/prompts`, {
    params: { contentId: contentId }
  })
    .then(PARSE_RESULT)
    .catch(RETURN_ERROR);
}

export const deletePromptGroup = (versionId, groupId) => {
  return OMNI_API.delete(`/prompts/${versionId}/groups`, {
    params: { groupId: groupId }
  })
    .then(PARSE_RESULT)
    .catch(LOG_ERROR);
}

export const getTags = () => {
  return OMNI_API.get(`/tags`).then(PARSE_RESULT);
};

export const getConversationTags = conversationId => {
  return OMNI_API.get(`/conversations/${conversationId}/tags`).then(PARSE_RESULT);
};

export const getMessageTags = conversationId => {
  return OMNI_API.get(`/messages/${conversationId}/tags`)
    .then(PARSE_RESULT)
    .catch(LOG_ERROR);
};

export const getSavedFilters = () => {
  return OMNI_API.get('/filters')
    .then(PARSE_RESULT)
    .catch(LOG_ERROR);
};

export const getSavedUltraliteFilters = () => {
  return OMNI_API.get('/ultralite/filters')
    .then(PARSE_RESULT)
    .catch(LOG_ERROR);
};

export const saveFilter = (filterObj) => {
  return OMNI_API.post('/filters', {
    filterObj: filterObj
  }).then(PARSE_RESULT);
};

export const saveUltraliteFilter = (filterObj) => {
  return OMNI_API.post('/ultralite/filters', {
    filterObj: filterObj
  }).then(PARSE_RESULT);
};

export const updateFilter = (filterObj) => {
  return OMNI_API.put('/filters', {
    filterObj: filterObj
  }).then(PARSE_RESULT);
}

export const updateUltraliteFilter = (filterObj) => {
  return OMNI_API.put('/ultralite/filters', {
    filterObj: filterObj
  }).then(PARSE_RESULT);
}

export const deleteFilter = (filterId) => {
  return OMNI_API.delete('/filters', {
    params: { filterId: filterId }
  }).then(PARSE_RESULT);
}

export const deleteUltraliteFilter = (filterId) => {
  return OMNI_API.delete('/ultralite/filters', {
    params: { id: filterId }
  }).then(PARSE_RESULT);
}


export const removeTag = (conversationId, tagId) => {
  return OMNI_API.delete(`/conversations/${conversationId}/tags/${tagId}`)
    .then(PARSE_RESULT);
};

export const deleteTag = (tagId) => {
  return OMNI_API.delete(`/tags/${tagId}`).then(PARSE_RESULT);
}

export const removeMessageTag = (messageId, tagId) => {
  return OMNI_API.delete(`/messages/${messageId}/tags`, {
    params: { id: tagId }
  }).then(PARSE_RESULT);
};

export const addTag = (conversationId, tagId) => {
  return OMNI_API.post(`/conversations/${conversationId}/tags/${tagId}`)
    .then(PARSE_RESULT);
};

export const addMessageTag = (messageId, tagName) => {
  return OMNI_API.post(`/messages/${messageId}/tags`, {
    tagName: tagName
  }).then(PARSE_RESULT);
};

export const createIssue = (summary, creationDate, conversationId, severity, description, projectName, ani, username, email, conversationUrl) => {
  return OMNI_API.post(`/conversations/${conversationId}/report`, {
    summary: summary,
    creationDate: creationDate,
    severity: severity,
    description: description,
    projectName: projectName,
    ani: ani,
    email: email,
    conversationUrl: conversationUrl
  }).then(PARSE_RESULT);
};

export const testHarness = (fileData) =>{
  return OMNI_API.post('/testHarness', fileData).then(PARSE_RESULT);
}

export const newTag = tagName => {
  return OMNI_API.post('/tags', {
    tagName: tagName
  }).then(PARSE_RESULT);
};

export const getConversationsByUser = (id, startTime) => {
  let params = {};
  if (startTime) params['startTime'] = startTime;

  return OMNI_API.get(`/users/${id}/conversations`, { params: params })
    .then(PARSE_RESULT)
    .catch(LOG_ERROR);
}

export const getConversationByUserId = (upId, sortBy, sortOrder, startTime) => {
  let params = {
    sortBy: sortBy || 'startTime',
    sortOrder: sortOrder || 'DESC'
  };

  if (startTime) {
    params['startTime'] = startTime;
    params['endTime'] = new Date().getTime();
  }

  return OMNI_API.get(`/users/${upId}/conversations`, { params: params })
    .then(PARSE_RESULT)
    .catch(LOG_ERROR);
};

export const getRoleNames = () => {
  return OMNI_API.get('/user/roles')
    .then(PARSE_RESULT);
};

export const getUserProfile = () => {
  return OMNI_API.get('/user').then(PARSE_RESULT);
}

export const getUsername = (guid) => {
  return OMNI_API.get(`/users/${guid}`)
    .then(PARSE_RESULT)
    .catch(LOG_ERROR);
};

export const deleteUserByGUID = guid => {
  return OMNI_API.delete(`/users/${guid}`)
    .then(PARSE_RESULT)
    .catch(LOG_ERROR);
};

export const purgeUserHistory = upId => {
  return OMNI_API.delete(`/users/${upId}/conversations`)
    .then(PARSE_RESULT)
    .catch(LOG_ERROR);
};


export const getMetadata = upId => {
  return OMNI_API.get(`/users/${upId}/metadata`)
    .then(PARSE_RESULT)
    .catch(LOG_ERROR);
};

export const getLastTask = upId => {
  return OMNI_API.get(`/users/${upId}/task`)
    .then(PARSE_RESULT)
    .catch(LOG_ERROR);
};

export const getGlobalId = upId => {
  return OMNI_API.get(`/users/${upId}`)
    .then(PARSE_RESULT)
    .catch(LOG_ERROR);
};

export const getIdpUsersCount = () => {
  return OMNI_API.get('/users/count')
    .then(PARSE_RESULT)
    .catch(LOG_ERROR);
};

export const getIdpUsers = (key, value, offset, limit) => {
  return OMNI_API.get(`/users/${encodeURIComponent(value)}`, {
    params: { key: key, offset: offset, limit: limit }
  })
    .then(PARSE_RESULT)
    .catch(LOG_ERROR);
};

export const getConversationsByGUID = (guid, startTime) => {
  let params = {};
  if (startTime) {
    params['startTime'] = startTime;
    params['endTime'] = new Date().getTime();
  }

  return OMNI_API.get(`/users/${guid}/conversations`, {
    params: params
  })
    .then(PARSE_RESULT)
    .catch(LOG_ERROR);
};

export const getReport = (reportType, queryParams) => {
  return OMNI_API.post(`/reporting/${reportType}`, {
    queryParams: queryParams
  })
    .then(PARSE_RESULT)
    .catch(LOG_ERROR);
}

export const getCallerUtterance = (reportType, queryParams) => {
  return OMNI_API.post(`/reporting-service/${reportType}`, {
    queryParams: queryParams
  }).then(PARSE_RESULT);
}

export const downloadReport = (fileName) => {
  return OMNI_API.get(`/reporting-service/${fileName}`, {
    responseType: 'blob'
  })
    .then(PARSE_RESULT)
    .then((data) => { download(data, fileName) })
    .catch(LOG_THROW_ERROR);
};

export const addComment = (conversationId, comment) => {
  return OMNI_API.post(`/conversations/${conversationId}/notes`, {
    comment: comment
  }).then(PARSE_RESULT);
};

export const deleteComment = (conversationId) => {
  return OMNI_API.delete(`/conversations/${conversationId}/notes`)
    .then(PARSE_RESULT);
};

export const addMessageComment = (messageId, comment) => {
  return OMNI_API.post(`/messages/${messageId}/notes`, {
    comment: comment
  }).then(PARSE_RESULT);
};

export const getUserIntents = (queryParams) => {
  return OMNI_API.post(`/users/${queryParams.guid}`, {}, {
    params: { startTime: queryParams.startTime, endTime: queryParams.endTime }
  })
    .then(PARSE_RESULT)
    .catch(LOG_ERROR);
};


export const getComments = (conversationId) => {
  return OMNI_API.get(`/conversations/${conversationId}/notes`)
    .then(PARSE_RESULT)
    .catch(LOG_ERROR);
}

export const getMessageComments = (messageId) => {
  return OMNI_API.get(`/messages/${messageId}/notes`)
    .then(PARSE_RESULT)
    .catch(LOG_ERROR);
}

export const getErrorLogs = (serviceName, sites) => {
  return OMNI_API.post('/logs', {
    serviceName: serviceName,
    sites: sites
  })
    .then(PARSE_RESULT)
    .catch(LOG_THROW_ERROR)
}

export const getServiceStatus = (serviceName) => {
  return OMNI_API.get(`/service/${serviceName}/status`)
    .then(PARSE_RESULT);
}

export const authUser = (username, password) => {
    return OMNI_API.post('/user/auth', {
      username: username,
      password: password
    }).then(PARSE_RESULT)
}

export const logout = () => {
  return OMNI_API.post('/user/logout')
}

export const userExpired = () => {
  return OMNI_API.get("/user/expired")
    .then(PARSE_RESULT)
    .catch(LOG_RETURN_ERROR);
};


export const createUser = (userProfile) => {
  return OMNI_API.post('/user', {
    userProfile: userProfile
  })
    .then(PARSE_RESULT)
    .catch(RETURN_ERROR);
}

export const getAllUsers = () => {
  return OMNI_API.get('/user/list')
    .then(PARSE_RESULT)
    .catch(LOG_RETURN_ERROR);
}

export const deleteUser = (username) => {
  return OMNI_API.delete('/user', {
    params: { username: username }
  })
    .then(PARSE_RESULT)
    .catch(RETURN_ERROR);
}

export const updateUser = (id, userProfile) => {
  return OMNI_API.put('/user', {
    userId: id,
    updatedProfile: userProfile
  })
    .then(PARSE_RESULT)
    .catch(RETURN_ERROR);
}

export const updatePassword = (username, password) => {
  return CSRF().then((data) => {
    return OMNI_API.post('/user/password/reset', {
      username: username,
      password: password
    }, {
      headers: { 'X-CSRF-TOKEN': data.token }
    })
  })
    .then(PARSE_RESULT)
    .catch(RETURN_ERROR);
}

export const getAllTenants = () => {
  return OMNI_API.get('/tenants')
    .then(PARSE_RESULT)
    .catch(RETURN_ERROR);
}

export const updateSettings = (settings) => {
  return OMNI_API.put('/settings', settings)
    .then(PARSE_RESULT)
    .catch(RETURN_ERROR);
}

export const getSettings = () => {
  return OMNI_API.get('/settings')
    .then(PARSE_RESULT)
    .catch(LOG_RETURN_ERROR);
}

export const getVersions = () => {
  return OMNI_API.get('/versions').then(PARSE_RESULT);
}

export const getIdpVersion = () => {
  return OMNI_API.get('/idp/version')
    .then(PARSE_RESULT)
    .catch(LOG_RETURN_ERROR);
}

export const getUpmVersion = () => {
  return OMNI_API.get('/upm/version')
    .then(PARSE_RESULT)
    .catch(LOG_RETURN_ERROR);
}

export const predictIntent = (phrase) => {
  return OMNI_API.post('/dm/model/parse', {
    text: phrase
  })
    .then(PARSE_RESULT)
    .catch(LOG_RETURN_ERROR);
}

export const getActiveUsers = () => {
  return OMNI_API.get('/user/active/count')
    .then(PARSE_RESULT)
    .then((data) => data.results);
}

export const uploadTrainingData = (file) => {
  return OMNI_API.post('/intents&entities/intents/upload', file)
    .then(PARSE_RESULT)
    .then((data) => data.results)
    .catch(LOG_RETURN_ERROR);
}

export const updatePrompt = (versionId, data) => {
  return OMNI_API.put(`/prompts/${versionId}/prompts`, data)
    .then(PARSE_RESULT);
}

export const deleteIntent = (intentId) => {
  return OMNI_API.delete(`/intents&entities/intents/${intentId}`)
    .then(PARSE_RESULT);
}

export const deleteTrainingPhrase = (intentId, phraseId) => {
  return OMNI_API.delete(`/intents&entities/intents/${intentId}/phrases`, {
    params: { phraseId: phraseId }
  }).then(PARSE_RESULT);
}

export const deleteEntity = (versionId, entityId) => {
  return OMNI_API.delete(`/intents&entities/${versionId}/entities`, {
    params: { id: entityId }
  }).then(PARSE_RESULT);
}

export const addEntity = (entityName, versionId) => {
  return OMNI_API.post(`/intents&entities/${versionId}/entities`, {
    entityName: entityName
  }).then(PARSE_RESULT);
};

export const addEntityDetail = (entityObj) => {
  return OMNI_API.post(`/intents&entities/phrases/${entityObj.PhraseId}/words`, {
    entityDetails: entityObj
  }).then(PARSE_RESULT);
};

export const deleteWordValue = (phraseId, valueId) => {
  return OMNI_API.delete(`/intents&entities/phrases/${phraseId}/words`, {
    params: { id: valueId }
  }).then(PARSE_RESULT);
}

export const getApiUrl = () => {
  return CONV_API_URL;
}

export const getUiUrl = () => {
  return UI_URL;
}

export const sendOutboundCall = (number, msg, params) => {
  let numberString ='+' + number
  if(number.toString().length === 10) numberString = '+1' + number

  return OMNI_API.post('/send_tts', {
    to: numberString,
    message: msg,
    triggers: params
  }, { validateStatus: OK })
    .then(PARSE_RESULT)
    .catch(RETURN_ERROR);
};

export const downloadRecording = (recordingId) => {
  return OMNI_API.get(`/messages/recordings/${recordingId}/downliad`, {
    responseType: 'blob'
  })
    .then(PARSE_RESULT)
    .then((data) => { download(data, recordingId)})
    .catch(LOG_ERROR);
};

export const downloadLink = (url, recId) => {
  return OMNI_API.get('/prism/download', {
    params: { url: url },
    responseType: 'blob'
  })
    .then(PARSE_RESULT)
    .then((data) => { download(data, recId) })
    .catch(LOG_ERROR);
}

export const getDomainData = (versionId) => {
  return OMNI_API.get('/reporting/domain', {
    versionId: versionId
  })
    .then(PARSE_RESULT)
    .catch(LOG_ERROR);
};

export const getActiveDomain = () => {
  return OMNI_API.get('/dm/domain').then(PARSE_RESULT);
};

export const updateDomainData = (yaml) => {
  return OMNI_API.post('/domain/update', {
    domain: yaml
  }).then(PARSE_RESULT);
};

export const getIntentSummary = (versionId) => {
  return OMNI_API.get(`/intents&entities/${versionId}/intents/summary`)
    .then(PARSE_RESULT)
    .then((data) => data.data);
};

export const getAudioOptions = () => {
  return OMNI_API.get('/prompts/audio/list')
    .then(PARSE_RESULT)
    .then((data) => data.data);
};

export const addAudio = (promptId, fileName ) => {
  return OMNI_API.put(`/prompts/audio/${promptId}/${fileName}`)
    .then(PARSE_RESULT);
};

export const deletePromptAudio = (promptId, fileName) => {
  return OMNI_API.delete(`/prompts/audio/${promptId}/${fileName}`)
    .then(PARSE_RESULT);
};

export const getSankey = (filter, startTime, endTime, type, lang, channelName, shouldShowPrev) => {
  return OMNI_API.get('/sankey/graph', {
    params: {
      filter: filter.map((name) => `'${name}'`).join(','),
      startTime: startTime,
      endTime: endTime,
      type: type,
      lang: lang,
      channelName: channelName,
      shouldShowPrev: shouldShowPrev,
    }
  }).then(PARSE_RESULT);
};

export const getSankeyEndStates = (reason, startTime, endTime, lang, channel) => {
  return OMNI_API.get('/sankey/endStates', {
    params: {
      reason: reason,
      startTime: startTime,
      endTime: endTime,
      lang: lang,
      channel: channel
    }
  }).then(PARSE_RESULT);
}

export const getConversationsByTT = (startDate, endDate, id, event, lang, channelId) => {
  return OMNI_API.post('/sankey/report', {
    startDate: startDate,
    endDate: endDate,
    nodeId: id,
    event: event,
    lang: lang,
    channelId: channelId
  })
    .then(PARSE_RESULT)
    .catch(LOG_ERROR);
}

export const getTTActivites = () => {
  return OMNI_API.get('/sankey/getTT')
    .then(PARSE_RESULT)
    .catch(LOG_ERROR);
}

export const getActivityList = () => {
  return OMNI_API.get('/analytics/getActivityList')
  .then(PARSE_RESULT)
  .catch(LOG_ERROR);
}

export const getReasonList = () => {
  return OMNI_API.get('/analytics/getReasonList')
  .then(PARSE_RESULT)
  .catch(LOG_ERROR);
}

export const getPrismMetadata = (conversationId, messageId) => {
  let url = !messageId ? `/prism/${conversationId}` : `/prism/${conversationId}/${messageId}`
  return OMNI_API.get(url).then(PARSE_RESULT).catch(LOG_RETURN_ERROR);
};

export const getPrismMetadataUnredacted = (conversationId, messageId) => {
  let url = !messageId ? `/prism/unredacted/${conversationId}` : `/prism/unredacted/${conversationId}/${messageId}`
  return OMNI_API.get(url).then(PARSE_RESULT).catch(LOG_RETURN_ERROR);
};

export const getPrismTranscript = (conversationId, messageId) => {
  return OMNI_API.get(`/prism/transcript/${conversationId}/${messageId}`)
    .then(PARSE_RESULT)
    .catch(LOG_RETURN_ERROR);
};

export const getActiveNLU = () => {
  return OMNI_API.get('/nlu', {
    responseType: 'text'
  }).then(PARSE_RESULT);
}

export const getActiveNluVersion = () => {
  return OMNI_API.get('/nlu/version')
    .then(PARSE_RESULT)
    .catch(RETURN_ERROR);
}

export const getActiveNluData = () => {
  return OMNI_API.get('/nlu/data')
    .then(PARSE_RESULT)
    .catch(RETURN_ERROR);
}

export const getSkills = () => {
  return OMNI_API.get('/cbsa/skills').then(PARSE_RESULT);
};

export const enqueueCaller = (phoneNumber) => {
  return OMNI_API.post('/cbsa/enqueue', {phoneNumber: phoneNumber}).then(PARSE_RESULT);
};

export const getCallbackConfigs = () => {
  return OMNI_API.get('/cbsa/config').then(PARSE_RESULT);
};

export const getNowData = (skill) => {
  return OMNI_API.get('/cbsa/data/now', {params: {skill: skill}}).then(PARSE_RESULT);
};

export const getTodayData = (interval, startDate, endDate, skill) => {
  return OMNI_API.get('/cbsa/data/today', {
    params: {
      interval: interval,
      startTime: startDate,
      endTime: endDate,
      skill: skill
    }
  }).then(PARSE_RESULT);
};

export const updateCallbackConfigs = (config) => {
  return OMNI_API.put('/cbsa/config', config).then(PARSE_RESULT);
};

export const newPasswordRequest = (email) => {
  return OMNI_API.post('/user/password/forgot', {
    email: email
  }).then(PARSE_RESULT);
}

export const fetchSettings = () => {
  return OMNI_API.get('/settings').then(PARSE_RESULT);
}

export const fetchPermissions = () => {
  return OMNI_API.get('/permissions').then(PARSE_RESULT);
}

export const checkPermissionAction = (location, action) => {
  let path = encodeURIComponent(location.substring(1))
  return OMNI_API.head(`/permissions/${path}/${action}`)
    .then(() => true)
    .catch(() => false);
}

export const getSankeyStats = (startAt, endAt) => {
  return OMNI_API.get('/sankey/stats', {
    params: { startAt: startAt, endAt: endAt }
  }).then(PARSE_RESULT);
}

export const getActivityEndStats = (activity, startAt, endAt, lang, channelId, isSuccessReport) => {
  return OMNI_API.get('/sankey/failStats', {
    params: { activity: activity, startAt: startAt, endAt: endAt, lang: lang, channelId: channelId, isSuccessReport: isSuccessReport }
  }).then(PARSE_RESULT);
}

export const getSurveys = (surveyName, startDate, endDate) => {
  let surveyNameQ = surveyName === "" ? "" : `/${surveyName}`;
  let params = { startDate: startDate };
  if (endDate) params['endDate'] = endDate;

  return OMNI_API.get(`/surveys${surveyNameQ}`, {
    params: params
  }).then(PARSE_RESULT);
}

export const getOutcomes = (startDate, endDate, channel, cancelToken) => {
  let params = {startDate: startDate, channel: channel };
  if(endDate) params['endDate'] = endDate;

  return OMNI_API.get(`analytics/outcomes`, {
    params: params,
    cancelToken
  }).then(PARSE_RESULT);
}

export const fetchOutcomesSettings = () => {
  return OMNI_API.get('/settings/outcomes')
    .then(PARSE_RESULT)
}

export const updateOutcomesSettings = (outcomeName, isContained) => {
  return OMNI_API.put('/settings/outcomes', {
    outcomeName: outcomeName,
    isContained: isContained
  }).then(PARSE_RESULT)
  .catch(RETURN_ERROR);
}

export const updateOutcomeIsArchived = (outcomeName, isArchived) => {
  return OMNI_API.put('/settings/outcomes/archived', {
    outcomeName: outcomeName,
    isArchived: isArchived
  }).then(PARSE_RESULT).catch(RETURN_ERROR);
}

export const insertOutcomesSettings = (nameValue, checkboxValue, archivedValue) => {
  return OMNI_API.post('/settings/outcomes', {
    nameValue: nameValue,
    checkboxValue: checkboxValue,
    archivedValue: archivedValue
  }).then(PARSE_RESULT)
  .catch(RETURN_ERROR);
}

export const deleteOutcomesSettings = (name) => {
  return OMNI_API.delete('/settings/outcomes/', {
    params: { name: name }
  }).then(PARSE_RESULT)
}

export const getHangups = (startDate, endDate, channel) => {
  let params = {startDate: startDate };
  if(endDate) params['endDate'] = endDate;
  if(channel) params['channel'] = channel;

  return OMNI_API.get(`analytics/hangups`, {
        params: params
  }).then(PARSE_RESULT);
}

export const getHOOTimetables = () => {
  return OMNI_API.get(`hoo/timetables`).then(PARSE_RESULT);
}

export const getHOOTimetableById = (id) => {
  let params = {id: id};
  return OMNI_API.get(`hoo/timetable`, {
    params: params
  }).then(PARSE_RESULT);
}

export const createNewHOOTimetable = (name, zoneId) => {
  return OMNI_API.post(`hoo/timetable`, {
    name: name,
    zoneId: zoneId
  }).then(PARSE_RESULT);
}

export const createNewHOOTimetableWithTemplate = (name, zoneId, timetable) => {
  return OMNI_API.post(`hoo/timetableTemplate`, {
    name: name,
    zoneId: zoneId,
    timetable: timetable
  }).then(PARSE_RESULT);
}

export const createNewSharedExceptionDay = (name, date, timezone) => {
  return OMNI_API.post(`hoo/globalExceptionTimes`, {
    name: name,
    date: date,
    timezone: timezone
  }).then(PARSE_RESULT);
}

export const deleteSharedExceptionDay = (id, name) => {
  let params = {id: id, name: name};
  return OMNI_API.delete(`hoo/globalExceptionTimes`, {
    params: params
  }).then(PARSE_RESULT);
}

export const updateSharedExceptionDay = (exceptionDay) => {
  return OMNI_API.put(`hoo/globalExceptionTimes`, {
    exceptionDay: exceptionDay
  }).then(PARSE_RESULT);
}

export const getSharedExceptionHoursList = () => {
  return OMNI_API.get(`hoo/globalExceptionTimesList`).then(PARSE_RESULT);
}

export const getSharedExceptionDay = (id) => {
  let params = {id: id}
  return OMNI_API.get(`hoo/globalExceptionDay`, {
    params: params
  }).then(PARSE_RESULT);
}

export const deleteHOOTimetable = (id, name) => {
  let params = {id: id, name: name};
  return OMNI_API.delete(`hoo/timetable`, {
    params: params
  }).then(PARSE_RESULT);
}

export const updateHOOTimetable = (timetable) => {
  return OMNI_API.put(`hoo/timetable`, {
    timetable: timetable
  }).then(PARSE_RESULT);
}

export const updateHOOTimetableV2 = (timetable) => {
  return OMNI_API.put(`hoo/timetable/v2`, {
    timetable: timetable
  }).then(PARSE_RESULT);
}

export const getHOOTimezones = () => {
  return OMNI_API.get(`hoo/timezones`).then(PARSE_RESULT);
}

export const getSharedExceptionHours = () => {
  return OMNI_API.get(`hoo/globalExceptionTimes`).then(PARSE_RESULT);
}

export const getMinorityReports = (startDate, endDate, language) => {
  let params = {startDate: startDate, language: language };
  if(endDate) params['endDate'] = endDate;

  return OMNI_API.get(`analytics/minorityreports`, {
            params: params
  }).then(PARSE_RESULT);
}

export const getMinorityReportDetails = (date, language) => {
  let params = {date: date, language: language};
  return OMNI_API.get(`analytics/minorityreports/details`, {
    params: params
  }).then(PARSE_RESULT)
}

export const getShortCalls = (startDate, endDate, threshold, channelId) => {
  let params = {startDate: startDate, channel: channelId };
  if(endDate) params['endDate'] = endDate;
  if(threshold) params['threshold'] = threshold;


  return OMNI_API.get(`analytics/shortcalls`, {
            params: params
  }).then(PARSE_RESULT);
}

/**
 *
 * @param {number} startDate
 * @param {number} endDate
 * @param type
 * @param channel
 * @returns {Promise<{ result: {
 *  actionName: string,
 *  total_count: number,
 *  no_match_count: number,
 *  no_input_count: number
 * }[] }>}
 */
export const getRecognitionData = (startDate, endDate, type, channel) => {
  let params = {startDate: startDate, endDate: endDate, type: type, channel: channel}
  return OMNI_API.get(`analytics/recognition`, {
    params: params
  }).then(PARSE_RESULT);
}

export const getRecognitionDrillDown = (action, recognition_type, startDate, endDate, channel) => {
  let params = {action: action, recognition_type: recognition_type, startDate: startDate, endDate: endDate, channel: channel}
  return OMNI_API.get(`analytics/recognitionDrillDown`, {
    params: params
  }).then(PARSE_RESULT);
}

export const getCBSALegacyTimetable = () => {
  return OMNI_API.get(`cbsa/legacyTimetable`)
    .then(PARSE_RESULT);
}

export const getCBSAOfferedCallbacksCount = (startTime, endTime, timerange, cancelToken) => {
  let params = {startTime : startTime, endTime: endTime, timerange: timerange, query: "offeredCallbacks"}
  return OMNI_API.get(`cbsa/metrics`, {
    params: params,
    cancelToken
  }).then(PARSE_RESULT);
}

export const getCBSAAcceptedCallbacksCount = (startTime, endTime, timerange, cancelToken) => {
  let params = {startTime : startTime, endTime: endTime, timerange: timerange, query: "acceptedCallbacks"}
  return OMNI_API.get(`cbsa/metrics`, {
    params: params,
    cancelToken
  }).then(PARSE_RESULT);
}

export const getCBSATransferredCallbacksCount = (startTime, endTime, timerange, cancelToken) => {
  let params = {startTime : startTime, endTime: endTime, timerange: timerange, query: "transferredCallbacks"}
  return OMNI_API.get(`cbsa/metrics`, {
    params: params,
    cancelToken
  }).then(PARSE_RESULT);
}

export const getCBSAQueueLength = (startTime, endTime, timerange, cancelToken) => {
  let params = {startTime : startTime, endTime: endTime, timerange: timerange, query: "queueDepth"}
  return OMNI_API.get(`cbsa/metrics`, {
    params: params,
    cancelToken
  }).then(PARSE_RESULT);
}

export const getCBSACallbackAttempts = (startTime, endTime, timerange, cancelToken) => {
  let params = {startTime : startTime, endTime: endTime, timerange: timerange, query: "callbackAttempts"}
  return OMNI_API.get(`cbsa/metrics`, {
    params: params,
    cancelToken
  }).then(PARSE_RESULT);
}

export const getCBSADispatchAttempts = (startTime, endTime, timerange, cancelToken) => {
  let params = {startTime : startTime, endTime: endTime, timerange: timerange, query: "dispatchAttempts"}
  return OMNI_API.get(`cbsa/metrics`, {
    params: params,
    cancelToken
  }).then(PARSE_RESULT);
}

export const getVoicemailCount = (startTime, endTime, timerange, cancelToken) => {
  let params = {startTime : startTime, endTime: endTime, timerange: timerange, query: "voicemailCount"}
  return OMNI_API.get(`cbsa/metrics`, {
    params: params,
    cancelToken
  }).then(PARSE_RESULT);
}

export const getNoAnswerCount = (startTime, endTime, timerange, cancelToken) => {
  let params = {startTime : startTime, endTime: endTime, timerange: timerange, query: "noAnswerCount"}
  return OMNI_API.get(`cbsa/metrics`, {
    params: params,
    cancelToken
  }).then(PARSE_RESULT);
}

export const getDeclinesCount = (startTime, endTime, timerange, cancelToken) => {
  let params = {startTime : startTime, endTime: endTime, timerange: timerange, query: "declinesCount"}
  return OMNI_API.get(`cbsa/metrics`, {
    params: params,
    cancelToken
  }).then(PARSE_RESULT);
}

export const getCBSARetriesCount = (startTime, endTime, timerange) => {
  let params = {startTime : startTime, endTime: endTime, timerange: timerange, query: "retriesCount"}
  return OMNI_API.get(`cbsa/metrics`, {
    params: params
  }).then(PARSE_RESULT);
}

export const getCBSAPenaltyBoxCallerCount = (startTime, endTime, timerange, cancelToken) => {
  let params = {startTime : startTime, endTime: endTime, timerange: timerange, query: "penaltyBoxCallersPenalized"}
  return OMNI_API.get(`cbsa/metrics`, {
    params: params,
    cancelToken
  }).then(PARSE_RESULT);
}

export const getCBSAPenaltyBoxMinuteCount = (startTime, endTime, timerange, cancelToken) => {
  let params = {startTime : startTime, endTime: endTime, timerange: timerange, query: "penaltyBoxMinutesPenalized"}
  return OMNI_API.get(`cbsa/metrics`, {
    params: params,
    cancelToken
  }).then(PARSE_RESULT);
}

export const getCBSADeniedEnqueueAlreadyPenalized = (startTime, endTime, timerange, cancelToken) => {
  let params = {startTime : startTime, endTime: endTime, timerange: timerange, query: "deniedEnqueueAlreadyPenalized"}
  return OMNI_API.get(`cbsa/metrics`, {
    params: params,
    cancelToken
  }).then(PARSE_RESULT);
}

export const getCBSADeniedEnqueueAlreadyEnqueued = (startTime, endTime, timerange, cancelToken) => {
  let params = {startTime : startTime, endTime: endTime, timerange: timerange, query: "deniedEnqueueAlreadyEnqueued"}
  return OMNI_API.get(`cbsa/metrics`, {
    params: params,
    cancelToken
  }).then(PARSE_RESULT);
}

export const getCBSAPenaltyBoxRemovedCount = (startTime, endTime, timerange, cancelToken) => {
  let params = {startTime : startTime, endTime: endTime, timerange: timerange, query: "penaltyBoxRemovals"}
  return OMNI_API.get(`cbsa/metrics`, {
    params: params,
    cancelToken
  }).then(PARSE_RESULT);
}

export const getCBSAQueueRemovedCount = (startTime, endTime, timerange, cancelToken) => {
  let params = {startTime : startTime, endTime: endTime, timerange: timerange, query: "queueRemovals"}
  return OMNI_API.get(`cbsa/metrics`, {
    params: params,
    cancelToken
  }).then(PARSE_RESULT);
}

export const getCallerEnqueueTotal = (startTime, endTime, timerange, cancelToken) => {
  let params = {startTime : startTime, endTime: endTime, timerange: timerange, query: "callersEnqueued"}
  return OMNI_API.get(`/cbsa/metrics`, {
    params: params,
    cancelToken
  }).then(PARSE_RESULT);
}

export const getTimetableMappingTimetable = (id) => {
  let params = {id: id}
  return OMNI_API.get(`/cbsa/timetablemapping/timetable`, {
    params: params
  }).then(PARSE_RESULT);
}

export const getTimetableMappings = () => {
  return OMNI_API.get(`/cbsa/timetablemapping/all`).then(PARSE_RESULT);
}

export const saveTimetableMapping = (object) => {
  return OMNI_API.put(`/cbsa/timetablemapping`, object)
    .then(PARSE_RESULT);
}

export const saveTimetableMappingSkills = (object) => {
  return OMNI_API.put(`cbsa/timetablemapping/skills`, object)
    .then(PARSE_RESULT);
}

export const getTimetableSkills = (id) => {
  let params = {id: id}
  return OMNI_API.get(`/cbsa/timetablemapping/skills`, {
    params: params
  }).then(PARSE_RESULT)
    .catch(exception => {
      throw exception;
    })
}

/**
 *
 * @return {Promise<ConfigurationManager.Application[]>}
 */
export const getApplications = () => {
  return OMNI_API.get(`/configuration-manager/applications`)
    .then(PARSE_RESULT)
    .catch(exception => {
      throw exception;
    });
}

export const getGroups = (applicationId) => {
  return OMNI_API.get(`/configuration-manager/${applicationId}/groups`)
    .then(PARSE_RESULT)
    .catch(exception => {
      LOG_RETURN_ERROR(exception);
    })
}

export const createGroup = (applicationId, groupCreateRequest) => {
  return OMNI_API.post(`/configuration-manager/${applicationId}/groups`, groupCreateRequest)
    .then(PARSE_RESULT)
    .catch(exception => {
      LOG_RETURN_ERROR(exception);
    })
}

export const createApplication = application => {
  return OMNI_API.post(`/configuration-manager/applications`, application)
    .then(PARSE_RESULT)
    .catch(exception => {
      throw exception;
    });
}

export const deleteGroup = (applicationId, groupId, groupName) => {
  return OMNI_API.delete(`/configuration-manager/${applicationId}/groups/${groupId}`, {params: {groupName: groupName}})
    .then(PARSE_RESULT)
    .catch(exception => {
      LOG_RETURN_ERROR(exception);
    })
}

export const updateGroup = (applicationId, group, originalName) => {
  return OMNI_API.put(`/configuration-manager/${applicationId}/groups`, {group: group, originalName: originalName})
    .then(PARSE_RESULT)
    .catch(exception => {
      LOG_RETURN_ERROR(exception);
    })
}

export const deleteApplication = application => {
  const queryParams = { name: application?.name, profile: application?.profile, label: application?.label, gitEnabled: application?.gitEnabled };
  return OMNI_API.delete(`/configuration-manager/applications/${application?.id}`, { params: queryParams })
    .then(PARSE_RESULT)
    .catch(exception => {
      throw exception;
    });
}

/**
 *
 * @param applicationId
 * @return {Promise<ConfigurationManager.Configuration[]>}
 */
export const getConfigurations = applicationId => {
  return OMNI_API.get(`/configuration-manager/${applicationId}/configurations`)
    .then(PARSE_RESULT)
    .catch(exception => {
      throw exception;
    });
}

export const createConfiguration = (applicationId, configuration) => {
  return OMNI_API.post(`/configuration-manager/${applicationId}/configurations`, configuration)
    .then(PARSE_RESULT)
    .catch(exception => {
      throw exception;
    });
}

export const updateConfiguration = (applicationId, configuration, oldConfig) => {
  return OMNI_API.put(`/configuration-manager/${applicationId}/configurations/${configuration?.id}`, { oldConfig: oldConfig, newConfig: configuration })
    .then(PARSE_RESULT)
    .catch(exception => {
      throw exception;
    });
}

export const updateConfigurations = (applicationId, configurations, oldConfigurations) => {
  return OMNI_API.put(`/configuration-manager/${applicationId}/configurations/updateMultiple`, {configurations: configurations, oldConfigurations: oldConfigurations})
    .then(PARSE_RESULT)
    .catch(exception => {
      throw exception;
    });
}

export const deleteConfiguration = (applicationId, configuration) => {
  let queryParams = { name: configuration?.name, format: configuration?.format, value: configuration?.value }
  return OMNI_API.delete(`/configuration-manager/${applicationId}/configurations/${configuration?.id}`, { params: queryParams })
    .then(PARSE_RESULT)
    .catch(exception => {
      throw exception;
    });
}

export const getLogsCM = () => {
  return OMNI_API.get(`/configuration-manager/logs`)
    .then(PARSE_RESULT)
    .catch(exception => {
      throw exception;
    });
}

export const getLogsHOOandCM = (offset = 0, pageSize = 10) => {
  return OMNI_API.get(`hoo/getLogsForHOOandCM`, {
    params: {
      offset,
      pageSize
    }
  })
    .then(PARSE_RESULT)
    .catch(exception => {
      throw exception;
    });
}
export const getLogsHOO = () => {
  return OMNI_API.get(`hoo/logs`)
    .then(PARSE_RESULT)
    .catch(exception => {
      throw exception;
    });
}

export const getLogsPagination = ({
  limit = 100,
  offset = 0,
  details = "",
  service = "",
  user = "",
  action = "",
  startTime = "",
  endTime = "",
  ascending = true,
} = {}) => {
  const queryParams = {
    limit,
    offset,
    ascending,
  };

  if (details) queryParams.details = details;
  if (service) queryParams.service = service;
  if (user) queryParams.user = user;
  if (action) queryParams.action = action;
  if (startTime) queryParams.startTime = startTime;
  if (endTime) queryParams.endTime = endTime;

  return OMNI_API.get("hoo/logspagination", { params: queryParams })
    .then((response) => {
      const parsed = PARSE_RESULT(response);
      return {
        total: parsed?.body?.hits?.total?.value || null,
        logs: parsed?.body?.hits?.hits || null,
      };
    })
    .catch((exception) => {
      throw exception;
    });
};


export const getConversationTransfer = (conversationId) => {
  return OMNI_API.get(`/conversations/${conversationId}/transfer_links`, {
  })
  .then(PARSE_RESULT);
}

export const ssoAuthenticate = () => {
  return CONV_API_URL + '/login'
}
export const getWebchatTransferMetrics = (startTime, endTime, timerange, token) => {
  let params = {startTime, endTime, timerange}
  return OMNI_API.get(`/analytics/webchatTransfer`, {
    params: params,
    token
  }).then(PARSE_RESULT);
}

export const permissionSettings = () => {
  return OMNI_API.get('/settings/permissions')
    .then(PARSE_RESULT)
}

export const updatePermissionSettings = (changeData) => {
  return OMNI_API.put('/settings/permissions', {
    data: changeData
  }).then(PARSE_RESULT)
}

export const getActions = () => {
  return OMNI_API.get('/settings/actions')
    .then(PARSE_RESULT);
};

export const deletePermission = (id) => {
  return OMNI_API.delete('/settings/permissions', {
    data: {permissionId: id}
  }).then(PARSE_RESULT);
};

export const createPermission = (permission) => {
  return OMNI_API.post('/settings/permissions', {
    data: {
      permission
    }
  }).then(PARSE_RESULT);
}
export const getCallerAuthMetrics = (startTime, endTime, channelId) => {
  return OMNI_API.get('/analytics/callerAuth', {params:{
    startTime: startTime,
    endTime: endTime,
    channelId: channelId
  }})
    .then(PARSE_RESULT);
};

export const getThresholdWidgetData = (startDate, endDate, cancelToken) => {
  return OMNI_API.get(`/analytics/threshold`, {
    params: { startDate: startDate, endDate: endDate },
    cancelToken
  }).then(PARSE_RESULT);
}

export const apiGateway = () => OMNI_API;
